import { type Ref } from 'react';
import ReactDatePicker from 'react-datepicker';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { Icon } from 'components/common';
import 'react-datepicker/dist/react-datepicker.css';

interface CustomInputProps {
  disabled?: boolean;
  id?: string;
  onClick?: (e: React.MouseEvent) => void;
  ref?: Ref<HTMLInputElement>;
  testId?: string | null;
  value?: string;
}

const CustomInput = ({ disabled, id, onClick, ref, testId = null, value }: CustomInputProps) => (
  <div className="position-relative w-100">
    <input
      className={classnames('cursor-pointer form-control text-0_875', {
        'bg-white': !disabled,
        'text-muted': disabled,
      })}
      data-testid={testId}
      disabled={disabled}
      id={id}
      onClick={onClick}
      readOnly
      ref={ref}
      type="text"
      value={value || 'YYYY-MM-DD'}
    />
    <span
      className="cursor-pointer end-0 me-2 position-absolute text-muted top-50 translate-middle-y"
      onClick={(event) => {
        if (!disabled) onClick!(event);
      }}
    >
      <span className="me-2">|</span>
      <Icon name="calendar-days" />
    </span>
  </div>
);

interface DatePickerProps {
  disabled?: boolean;
  id: string;
  label: string;
  minDate?: Date | null;
  onChange: (date: Date | null) => void;
  selected?: Date | null;
  testId?: string | null;
}

const DatePicker = ({
  disabled = false,
  id,
  label,
  minDate = null,
  onChange,
  selected,
  testId = null,
}: DatePickerProps) => (
  <div className="d-flex flex-column">
    <label className="fw-bold mb-2" htmlFor={id}>
      {label}
    </label>
    <ReactDatePicker
      customInput={<CustomInput disabled={disabled} id={id} testId={testId} />}
      dateFormat="yyyy-MM-dd"
      disabled={disabled}
      id={id}
      minDate={minDate ?? dayjs().toDate()}
      onChange={onChange}
      popperClassName="z-[9999]"
      popperPlacement="bottom-start"
      selected={selected}
    />
  </div>
);

export default DatePicker;
